export default __webpack_public_path__ + "static/media/Boots of the Furious Swipe.1602fa76.jpg";